import { render, staticRenderFns } from "./OrdersService.vue?vue&type=template&id=4f11a8e4"
import script from "../../script/customer-service/ordersService.js?vue&type=script&lang=js&external"
export * from "../../script/customer-service/ordersService.js?vue&type=script&lang=js&external"
import style0 from "../../less/customer-service/ordersService.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports